export default "__VITE_ASSET__AXdkCcK5__"